"use strict";

exports.__esModule = true;
exports.makeValuePresentation = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
var _value = require("../../entities/value");
const makeValuePresentation = ({
  dataType,
  format,
  fieldType,
  value
}, dependencies) => {
  const formattedValue = formatValue({
    format,
    fieldType,
    value
  }, dependencies);
  const convertedValue = convertValueByDataType({
    dataType,
    fieldType,
    value: formattedValue
  });
  return convertedValue;
};

//TODO: Inline constant - issues with tree-shaking of wix-data-client-common
exports.makeValuePresentation = makeValuePresentation;
const DATETIME_FORMAT_TYPE = 'datetime';
const dateFieldTypes = [_wixDataSchemaTypes.FieldType.date, _wixDataSchemaTypes.FieldType.time, _wixDataSchemaTypes.FieldType.dateTime];
const formatValue = ({
  format: {
    type,
    params
  } = {},
  fieldType,
  value
}, dependencies) => {
  if (type === DATETIME_FORMAT_TYPE && (dateFieldTypes.includes(fieldType) || _value.Value.isIsoString(value))) {
    return applyDateFormat({
      fieldType,
      value,
      dateFormat: params.dateFormat
    }, dependencies);
  }
  return applyDefaultFormat({
    fieldType,
    value
  });
};
const convertValueByDataType = ({
  value,
  fieldType,
  dataType
}) => {
  const convert = dataTypeToValueConverter[dataType] ?? dataTypeToValueConverter.default;
  return convert({
    fieldType,
    value
  });
};
const applyDateFormat = ({
  dateFormat,
  fieldType,
  value
}, {
  formatter
}) => {
  const dateTimeValue = fieldType === _wixDataSchemaTypes.FieldType.time ? `1970-01-01T${value}Z` : value;
  const date = new Date(dateTimeValue);
  if (isNaN(date.getTime()) || fieldType === _wixDataSchemaTypes.FieldType.dateTime && !_value.Value.isIsoString(value)) {
    return value;
  }
  const timeZone = fieldType === _wixDataSchemaTypes.FieldType.date || fieldType === _wixDataSchemaTypes.FieldType.time ? 'UTC' : undefined;
  return formatter.formatDateTime(date.toISOString(), dateFormat, {
    timeZone
  });
};
const applyDefaultFormat = ({
  fieldType,
  value
}) => value && (fieldType === _wixDataSchemaTypes.FieldType.dateTime || _value.Value.isIsoString(value)) ? new Date(value).toString() : value;
const dataTypeToValueConverter = {
  text: ({
    fieldType,
    value
  }) => {
    if (value === null || value === undefined) {
      return '';
    } else if (Array.isArray(value)) {
      return value.join(', ');
    } else if (fieldType === _wixDataSchemaTypes.FieldType.address) {
      return typeof value === 'object' && 'formatted' in value ? value.formatted : value;
    } else {
      return String(value);
    }
  },
  default: ({
    value
  }) => value
};
//# sourceMappingURL=make-value-presentation.js.map